import { render, staticRenderFns } from "./qualityControl.vue?vue&type=template&id=8975560e&"
import script from "./qualityControl.vue?vue&type=script&lang=js&"
export * from "./qualityControl.vue?vue&type=script&lang=js&"
import style0 from "./qualityControl.vue?vue&type=style&index=0&lang=less&"
import style1 from "./qualityControl.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports